import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";

import {HomeComponent} from "./home/home.component";
import {ShellComponent} from "./shell/shell.component";
import {ContactComponent} from "./contact/contact.component";
import {LoginComponent} from "./login/login.component";
import {RegisterComponent} from "./register/register.component";
import {ResetComponent} from "./reset/reset.component";
import {ResetRequestComponent} from "./reset-request/reset-request.component";

const routes: Routes = [
    /*{
        path: "",
        component: ShellComponent,
        children: [
            {path: "", component: HomeComponent},
            {
                path: "adviser",
                loadChildren: () => import("./adviser/adviser.module").then(m => m.AdviserModule)
            },
            {
                path: "firms",
                loadChildren: () => import("./firms/firms.module").then(m => m.FirmsModule)
            },
            {
                path: "personal",
                loadChildren: () => import("./personal/personal.module").then(m => m.PersonalModule)
            },
            {
                path: "about",
                loadChildren: () => import("./about/about.module").then(m => m.AboutModule)
            },
            {
                path: "contact",
                component: ContactComponent
            },
            {
                path: "legal",
                loadChildren: () => import("./legal/legal.module").then(m => m.LegalModule)
            }
        ]
    },*/
    {
        path: "",
        pathMatch: "full",
        redirectTo: "login"
    },
    {
        path: "signin",
        redirectTo: "login"
    },
    {
        path: "login",
        component: LoginComponent
    },
    // {
    //     path: "register",
    //     component: RegisterComponent
    // },
    {
        path: "reset/:token",
        pathMatch: "full",
        component: ResetComponent,
    },
    {
        path: "reset",
        component: ResetRequestComponent
    },
    {
        path: "legal",
        loadChildren: () => import("./legal/legal.module").then(m => m.LegalModule)
    },
    {
        path: "**",
        redirectTo: "/"
    }
]

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: "top"
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
